import tw, { styled } from 'twin.macro';

const TextArea = styled.textarea(({ variant = 'dark' }) => [
  tw`focus:border-green-100 focus:ring-2 focus:ring-green-100 w-full px-4 py-2 mt-1 text-base leading-8 text-white placeholder-black transition-colors duration-200 ease-in-out bg-green-darker outline-none`,
  variant === 'dark' &&
    tw`placeholder-gray-300 bg-green-darker focus:ring-green-100`,
  variant === 'light' && tw`bg-white placeholder-gray`,
]);

export default TextArea;
